import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/users";

/**
 * PBI #297: the customer's own Entra groups, offered on the SCO onboarding form so the
 * orderer can request the same access a colleague already has.
 *
 * The answer carries the sync status and age as well as the groups, because an empty list
 * on its own cannot tell a customer with no groups from one whose administrator has not
 * yet approved Insight's access to read them.
 *
 * The optional chaining is deliberate: a bare network failure carries no `response`, and
 * reading it unguarded throws a TypeError instead of an error the caller can show.
 */
export async function getGroupOptionsByTenant(tenantPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/EntraGroups/get-group-options-by-tenant/${tenantPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch group options"
    );
  }
}

/**
 * PBI #297: the groups one existing user belongs to, used to pre-tick the picker when the
 * orderer copies from that person. Public ids only — the names come from the group list
 * the picker already holds.
 */
export async function getUserGroupMemberships(userPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/EntraGroups/get-user-group-memberships/${userPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch group memberships"
    );
  }
}
